module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("languages")))]), _vm._v(" "), _vm._l((_vm.languages), function(item) {
    return _c('li', [_c('a', {
      class: {
        'current-lang': _vm.currentLangCode === item.code
      },
      attrs: {
        "herf": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.changeLang(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a87e482a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chooseLangInFooter/ChooseLangInFooter.vue
// module id = 1375
// module chunks = 1